import { useEffect, useRef } from 'react';
import { isMobile } from 'is-mobile';

export const useOnTouchOutside = (shallListenOnClick, onClickOutside) => {
  const ref = useRef(null);

  useEffect(() => {
    const listener = (event) => {
      const clickedElement = event.target;

      if (ref.current && !ref.current.contains(clickedElement)) {
        onClickOutside(event);
      }
    };

    if (shallListenOnClick) {
      if (isMobile({ tablet: true })) {
        document.addEventListener('touchend', listener);
      } else {
        document.addEventListener('mouseup', listener);
      }
    }

    return () => {
      document.removeEventListener('touchend', listener);
      document.removeEventListener('mouseup', listener);
    };
  }, [onClickOutside, shallListenOnClick]);

  return ref;
};
